// src/pages/admin/settings/index.jsx
import React, { useState } from 'react';
import { useAdminAuth } from '../../../context/AdminAuthContext';
import AdminLayout from '../layout';
import ProfileSettingsTab from '../../../component/admin/settings/ProfileSettingsTab';
import AdminUsersTab from '../../../component/admin/settings/AdminUsersTab';
import RolesPermissionsTab from '../../../component/admin/settings/RolesPermissionsTab';
import DiscountPromoTab from '../../../component/admin/settings/DiscountPromoTab';
import SupportNotificationTab from '../../../component/admin/settings/SupportNotificationTab';

const SettingsPage = () => {
  const [activeTab, setActiveTab] = useState('profile');
  const { admin } = useAdminAuth();

  const tabs = [
    { id: 'profile', label: 'Profile Settings' },
    { id: 'admin-users', label: 'Admin & Users' },
    { id: 'roles', label: 'Roles & Permission' },
  ];

  const renderActiveTab = () => {
    switch (activeTab) {
      case 'profile':
        return <ProfileSettingsTab />;
      case 'admin-users':
        return <AdminUsersTab />;
      case 'roles':
        return <RolesPermissionsTab />;
      case 'discount':
        return <DiscountPromoTab />;
      case 'support':
        return <SupportNotificationTab />;
      default:
        return <ProfileSettingsTab />;
    }
  };

  return (
    <AdminLayout>
      <div className="space-y-4 sm:space-y-6 px-2 sm:px-0">
        {/* Tab Navigation - Responsive with horizontal scroll */}
        <div className="border-b-2 overflow-x-auto">
          <div className="flex min-w-max sm:min-w-0">
            {tabs.map((tab) => (
              <button
                key={tab.id}
                onClick={() => setActiveTab(tab.id)}
                className={`px-4 sm:px-6 md:px-8 py-3 sm:py-4 text-xs sm:text-sm font-medium border-b-2 transition-colors whitespace-nowrap ${
                  activeTab === tab.id
                    ? 'border-[#55000C] text-[#55000C]'
                    : 'border-transparent text-[#6B635D] hover:text-[#1C2A46]'
                }`}
              >
                {tab.label}
              </button>
            ))}
          </div>
        </div>

        {/* Tab Content */}
        <div className="mt-2 sm:mt-4">
          {renderActiveTab()}
        </div>
      </div>
    </AdminLayout>
  );
};

export default SettingsPage;